import potkrovlje1 from '../assets/img/aprtmani_novo/Potkrovlje 1 - 1.jpg'
import potkrovlje1i2 from '../assets/img/aprtmani_novo/Potkrovlje 1 - 2.jpg'
import potkrovlje1i3 from '../assets/img/aprtmani_novo/Potkrovlje 1 - 3.jpg'
import potkrovlje1i4 from '../assets/img/aprtmani_novo/Potkrovlje 1 - 4.jpg'

const potkrovlje = [
    {
        id: 61,
        title: 'Potkrovlje 1',
        text: 'Prostire se na dve poslednje etaže, definisan tako da je dnevni boravak sa kuhinjom, kupatilom i ulaznim delom smešten na prvi nivo dok je noćna zona spavanje na drugom nivou u vidu galerije otvorenog prostora do koga vodi stepenište.',
        size: '20.7',
        image: potkrovlje1
    },
    {
        id: 72,
        title: 'Potkrovlje 1-2',
        text: 'Prostire se na dve poslednje etaže, definisan tako da je dnevni boravak sa kuhinjom, kupatilom i ulaznim delom smešten na prvi nivo dok je noćna zona spavanje na drugom nivou u vidu galerije otvorenog prostora do koga vodi stepenište.',
        size: '20.7',
        image: potkrovlje1i2
    },
    {
        id: 85,
        title: 'Potkrovlje 1-3',
        text: 'Prostire se na dve poslednje etaže, definisan tako da je dnevni boravak sa kuhinjom, kupatilom i ulaznim delom smešten na prvi nivo dok je noćna zona spavanje na drugom nivou u vidu galerije otvorenog prostora do koga vodi stepenište.',
        size: '31.4',
        image: potkrovlje1i3
    },
    {
        id: 97,
        title: 'Potkrovlje 1-4',
        text: 'Prostire se na dve poslednje etaže, definisan tako da je dnevni boravak sa kuhinjom, kupatilom i ulaznim delom smešten na prvi nivo dok je noćna zona spavanje na drugom nivou u vidu galerije otvorenog prostora do koga vodi stepenište.',
        size: '31.4',
        image: potkrovlje1i4
    },

]

export default potkrovlje;